module.exports = __webpack_public_path__ + "static/media/icon-turkcell.25094e5b.svg";